var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-3-rows",class:{
    'text-3-rows--one-row': _vm.loading,
    active: _vm.active,
  },attrs:{"role":_vm.btn ? 'button' : 'text'}},[_c('b-skeleton-wrapper',{attrs:{"loading":_vm.loading},scopedSlots:_vm._u([{key:"loading",fn:function(){return [_c('b-skeleton',{attrs:{"type":"text","width":"92px","height":"86px"}})]},proxy:true}])},[_c('span',{staticClass:"text-3-rows__top"},[_vm._t("top")],2),_c('span',[_vm._t("middle")],2),_c('div',{staticClass:"text-3-rows__bottom"},[_vm._t("bottom")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }